// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"5b2c0753","166":"704a4b3b","229":"82576341","233":"e9731cba","675":"46ae47c5","787":"d3e2ca60","795":"f40ed5c1","929":"45167299"}[chunkId] + ".chunk.js";
};